var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page-navigation-back-button",
      attrs: { id: "page-navigation-back-button" }
    },
    [
      _c(
        "button",
        {
          staticClass: "d-inline-flex btn btn-sm btn-light",
          attrs: {
            type: "button",
            onclick: "history.back()",
            "aria-label": "Back"
          }
        },
        [
          _c("span", {
            staticClass:
              "\n        png-icon png-icon-icons-glyph--k-carrot-back-title d-inline d-lg-none"
          }),
          _vm._v(" "),
          _c("span", {
            staticClass:
              "\n      png-icon png-icon-icons-glyph--k-arrow-left-sm d-none d-lg-inline"
          }),
          _vm._v(" "),
          _c("span", { staticClass: "d-none d-lg-inline pl-1" }, [
            _vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }